// socket.js
import io from 'socket.io-client'
import Config from '../../Config'

const socket = io(Config.SETTINGS.SOCKET_URL, { autoConnect: false })
export default socket.connect()